import { useCallback } from "react";
import { api } from "services/api.service";
import useAnalytics from "hooks/analytics/useAnalytics";
import { OauthApplication } from "types/oauthApplication";

interface oauthProps {
  name: string;
}

export default function useCreateOauthApplication() {
  const { createAnalyticsEvent } = useAnalytics();

  const create = useCallback((oauthApplication: oauthProps) => {
    createAnalyticsEvent("created_oauth_application");
    return api.post<OauthApplication>("/oauth_applications", { oauthApplication }).then((res) => res.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    create,
  };
}
